const backBtnDirective = function ($window) {
    return {
        restrict: 'A',
        link: function (scope, elem) {
            elem.bind('click', function () {
                $window.history.back();
            });
        },
    };
};

module.exports = backBtnDirective;
